import { Inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { ScriptLoaderService } from './script-loader.service';
import { WINDOW } from './window.service';

@Injectable({
    providedIn: 'root',
})
export class TrustpilotService {
    widgetTheme: Observable<string>;

    constructor(
        @Inject(WINDOW) private window: Window,
        private scriptLoaderService: ScriptLoaderService,
        private environmentService: EnvironmentService
    ) {}

    loadTrustPilotWidget(widgetElement: HTMLElement, theme?: string) {
        if (theme && this.environmentService.isBrowser()) {
            // setting the theme of widget element before loading the script
            widgetElement.dataset.theme = theme;
        }
        const script = this.scriptLoaderService
            .load(
                'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
            )
            .pipe(
                tap(() => {
                    (this.window as any)?.Trustpilot?.loadFromElement(
                        widgetElement
                    );
                })
            );
        return script;
    }
}
